import { memo } from 'react'

const AddPaymentCardDialogStatus = ({
    message,
    handleModal,
}) => {
    
    return (<>
        
        <div className="modal-body">
            <div className="p-2">
                {message}
            </div>
        </div>
        
        <div className="mb-2 modal-footer flex justify-end">
            <button
                type="button"
                className="mr-3 btn btn-primary btn-outline"
                onClick={() => handleModal(true)}>
                {/* @todo hacky */}
                {message?.includes('Success!') ? 'OK' : 'Save Changes'}
            </button>
        </div>
    
    </>)
    
}

export default memo(AddPaymentCardDialogStatus)
